import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { useId } from '../../../hooks';

export default function RadioToggle({
    id: userId,
    ariaLabel,
    options = [],
    value,
    onChange,
    className,
    isInvalid,
    isDisabled,
    isRequired,
    onBlur,
    ...rest
}) {
    const id = useId(userId);

    return (
        <div
            data-component="RadioToggle"
            className={cx(className, {
                invalid: isInvalid,
                disabled: isDisabled,
            })}
            {...rest}
        >
            {ariaLabel && (
                <div className="rec-sr-only" id={`${id}-ariaLabel`}>
                    {ariaLabel}
                </div>
            )}

            <div data-input-wrapper>
                {options.map((option, index) => (
                    <Fragment key={option.value}>
                        <input
                            type="radio"
                            id={`${id}-${index}`}
                            name={`${id}-group-name`}
                            required={isRequired}
                            disabled={isDisabled}
                            value={option.value}
                            checked={value ? value === option.value : null}
                            aria-describedby={ariaLabel ? `${id}-ariaLabel` : null}
                            onChange={onChange}
                            onBlur={onBlur}
                            className="rec-sr-only"
                        />
                        <label htmlFor={`${id}-${index}`}>{option.label}</label>
                    </Fragment>
                ))}
            </div>
        </div>
    );
}

RadioToggle.propTypes = {
    /** Screen reader-only description of radio group */
    ariaLabel: PropTypes.string,

    /** Base id used for inputs. If not provided, one is generated automatically */
    id: PropTypes.string,

    /** A radio button is rendered for each option in the array using the label */
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string,
        })
    ).isRequired,

    /** Value of the currently selected radio button */
    value: PropTypes.string.isRequired,

    /** Change handler. Returns the input event */
    onChange: PropTypes.func.isRequired,

    /** Styles the control as invalid */
    isInvalid: PropTypes.bool,

    /** Disables the entire button group */
    isDisabled: PropTypes.bool,

    /** Marks the control as required */
    isRequired: PropTypes.bool,
    onBlur: PropTypes.func,
    className: PropTypes.string,
};
